import ActionSourceTooltip from 'src/features/groups/components/ActionSourceTooltip';
import useTenantNavigate from 'src/hooks/useTenantNavigate';

export type DocumentSourcePill = {
  document_id: string;
  document_name: string;
  source_element_id: string;
  source_type: string;
  content: string;
  page_index: number;
  caption: string | null;
  figure_id: number | null;
};

function sourceElementType(source: DocumentSourcePill): 'paragraph' | 'table' | 'figure' {
  return source.source_type === 'figure' || source.source_type === 'table' || source.source_type === 'paragraph'
    ? source.source_type
    : 'paragraph';
}

/** The document-and-page pills the evidence list uses for a requirement's sources. */
export default function DocumentSourcePills({ sources }: { sources: readonly DocumentSourcePill[] }) {
  const navigate = useTenantNavigate();
  return (
    <>
      {sources.map((source) => (
        <ActionSourceTooltip
          key={source.source_element_id}
          sourceElement={{
            id: source.source_element_id,
            type: sourceElementType(source),
            content: source.content,
            page_index: source.page_index,
            figure_id: source.figure_id,
            caption: source.caption
          }}
          documentExternalId={source.document_id}
          clickable
        >
          <button
            type="button"
            className="inline-flex max-w-[180px] items-center rounded-full bg-surface-hover px-2 py-0.5 text-xs font-medium text-content-subtle hover:bg-bluegray-100"
            onClick={(event) => {
              event.stopPropagation();
              navigate(`/wiki/${source.document_id}#element_ids=${source.source_element_id}`);
            }}
          >
            <span className="truncate">{source.document_name}</span>
            <span className="shrink-0">{`, p. ${source.page_index > 0 ? source.page_index : '?'}`}</span>
          </button>
        </ActionSourceTooltip>
      ))}
    </>
  );
}
